//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LABEL_MARKS } from './RequestWorkTypes.js'
import RequestWorkTypeListElement from './RequestWorkTypeListElement.vue'
import RequestWorkPackageListElement from './RequestWorkPackageListElement.vue'
import RequestTechnologicalOperationListElement from './RequestTechnologicalOperationListElement.vue'
import RequestWorkTypesListHelp from './RequestWorkTypesListHelp.vue'
import { mapGetters } from 'vuex'
import RequestWorksGroupInclusionModeEditor from './RequestWorksGroupInclusionModeEditor.vue'

export default {
  name: 'RequestWorkTypesList',
  components: {
    RequestWorkTypeListElement,
    RequestWorkPackageListElement,
    RequestTechnologicalOperationListElement
  },
  props: {
    workTypes: {
      type: Array,
      default () {
        return []
      }
    },
    workPackages: {
      type: Array,
      default: null
    },
    workTypesInitial: {
      type: Array,
      default: null
    },
    workPackagesInitial: {
      type: Array,
      default: null
    },
    showWorkPackages: {
      type: Boolean,
      default () {
        return false
      }
    },
    request: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    hideInclusionMode: {
      type: Boolean,
      default: false
    },
    hideIndicators: {
      type: Boolean,
      default: false
    },
    hideActionButtons: {
      type: Boolean,
      default: false
    },
    engineerView: {
      type: Boolean,
      default: false
    },
    setupTechnologicalOperations: {
      type: Boolean,
      default: false
    },
    expandAll: {
      type: Boolean,
      default: false
    },
    isAdditionalDepartureForm: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      group: false,
      labelMarks: LABEL_MARKS,

      workTypesLocal: JSON.parse(JSON.stringify(this.workTypes)),
      workPackagesLocal: JSON.parse(JSON.stringify(this.workPackages)),

      hoveredWorkTypeId: null,

      expandWorkPackages: {},
      expandOtherWorks: true
    }
  },
  computed: {
    ...mapGetters({
      defaultWorkTypes: 'getWorkTypes'
    }),
    hasUnsavedChanges: function () {
      if (!this.workTypesInitial || !this.workPackagesInitial) {
        return false
      }
      return this.workTypesLocal.length !== this.workTypesInitial.length ||
      this.workPackagesLocal.length !== this.workPackagesInitial.length ||
      this.workTypesLocal.some(wT => {
        const wTInitial = this.workTypesInitial.find(wTI => wTI.id === wT.id)
        return !wTInitial || JSON.stringify(wT) !== JSON.stringify(wTInitial)
      }) ||
      this.workPackagesLocal.some(wP => {
        const wPInitial = this.workPackagesInitial.find(wPI => wPI.id === wP.id)
        return !wPInitial || JSON.stringify(wP) !== JSON.stringify(wPInitial)
      })
    },
    hasUnsavedModesChanges: function () {
      if (!this.workTypesInitial || !this.workPackagesInitial) {
        return false
      }
      return this.hasUnsavedChanges && this.workTypesLocal.some(wT => {
        const initialWorkType = this.workTypesInitial.find(wTI => wTI.id === wT.id)
        return initialWorkType && initialWorkType.inclusionMode !== wT.inclusionMode
      }) ||
        this.workPackagesLocal.some(wP => wP.workTypes.some(wT => {
          const initialWorkPackage = this.workPackagesInitial.find(wPI => wPI.id === wP.id)
          if (initialWorkPackage) {
            const initialWorkType = initialWorkPackage.workTypes.find(wTI => wTI.id === wT.id)
            return initialWorkType && initialWorkType.inclusionMode !== wT.inclusionMode
          } else {
            return false
          }
        }))
    },
    groupedWorkTypes: function () {
      const workTypesFromPackages = new Map()
      this.workPackagesLocal.forEach(wP => {
        wP.workTypes.forEach(wT => {
          if (!workTypesFromPackages.has(wT.id)) {
            workTypesFromPackages.set(wT.id, {
              ...wT,
              workPackages: [
                {
                  name: wP.name,
                  id: wP.id
                }
              ]
            })
          } else {
            workTypesFromPackages.get(wT.id).workPackages.push({
              name: wP.name,
              id: wP.id
            })
          }
        })
      })
      return [
        ...this.workTypesLocal,
        ...Array.from(workTypesFromPackages.values())
      ].sort((a, b) => {
        const aDone = a.done || a.hasDoneMultipleReports ? 2 : a.hasDonePartiallyReports ? 1 : 0
        const bDone = b.done || b.hasDoneMultipleReports ? 2 : b.hasDonePartiallyReports ? 1 : 0
        if (aDone !== bDone) {
          return aDone > bDone ? -1 : 1
        } else {
          return a.name.localeCompare(b.name)
        }
      })
    },
    expandOtherWorksStorageKey: function () {
      return `expandOtherWorks_${this.request.id}`
    },
    expandAllLocal: function () {
      return !!(this.expandAll || this.setupTechnologicalOperations)
    },
    requiredAll: function () {
      return this.workTypesLocal.every(wT => wT.technologicalOperations.every(tO => tO.required)) && this.workPackagesLocal.every(wP => wP.workTypes.every(wT => wT.technologicalOperations.every(tO => tO.required)))
    },
    resultsRequiredAll: function () {
      return this.workTypesLocal.every(wT => wT.technologicalOperations.every(tO => tO.resultsRequired)) && this.workPackagesLocal.every(wP => wP.workTypes.every(wT => wT.technologicalOperations.every(tO => tO.resultsRequired)))
    },
    isAdditionalDeparture: function () {
      return this.request.additionalDepartureExpected || this.isAdditionalDepartureForm
    },
    hoveredWorkTypeHasDuplicates: function () {
      const workTypesWithHoveredId = [
        ...this.workTypes.filter(wT => wT.id === this.hoveredWorkTypeId),
        ...this.workPackages
          .filter(wP => wP.workTypes.some(wT => wT.id === this.hoveredWorkTypeId))
          .map(wP => wP.workTypes.filter(wT => wT.id === this.hoveredWorkTypeId))
          .flat()
      ]
      return workTypesWithHoveredId.length > 1
    },
    isAllExpanded: function () {
      return this.showWorkPackages ? Object.values(this.expandWorkPackages).every(v => v) && this.expandOtherWorks : this.expandOtherWorks
    }
  },
  watch: {
    workTypes: {
      handler (newValue) {
        this.workTypesLocal = JSON.parse(JSON.stringify(newValue))
        this.expandOtherWorks = true
      },
      deep: true
    },
    workPackages: {
      handler (newValue) {
        this.workPackagesLocal = JSON.parse(JSON.stringify(newValue))
        this.workPackagesLocal.forEach(wP => {
          if (!Object.hasOwnProperty.call(this.expandWorkPackages, wP.key)) {
            this.$set(this.expandWorkPackages, wP.key, true)
          }
        })
      },
      deep: true
    },
    expandWorkPackages: {
      handler (newValue) {
        if (!this.expandAllLocal) {
          for (const [key, value] of Object.entries(newValue)) {
            const targetWorkPackage = this.workPackagesLocal.find(wP => wP.key === key)
            sessionStorage.setItem(this.getWorkPackageExpansionStorageKey(targetWorkPackage), JSON.stringify(value))
          }
        }
      },
      deep: true
    },
    expandOtherWorks: {
      handler (newValue) {
        if (!this.expandAllLocal) {
          sessionStorage.setItem(this.expandOtherWorksStorageKey, JSON.stringify(newValue))
        }
      }
    }
  },
  created: function () {
    const expandAll = this.expandAllLocal
    this.workPackagesLocal.forEach(wP => {
      if (!expandAll) {
        if (sessionStorage.getItem(this.getWorkPackageExpansionStorageKey(wP)) !== null) {
          this.$set(this.expandWorkPackages, wP.key, JSON.parse(sessionStorage.getItem(this.getWorkPackageExpansionStorageKey(wP))))
        } else {
          this.$set(this.expandWorkPackages, wP.key, true)
        }
      } else {
        this.$set(this.expandWorkPackages, wP.key, true)
      }
    })
    if (!expandAll) {
      if (sessionStorage.getItem(this.expandOtherWorksStorageKey) !== null) {
        this.expandOtherWorks = JSON.parse(sessionStorage.getItem(this.expandOtherWorksStorageKey))
      } else {
        this.expandOtherWorks = true
        sessionStorage.setItem(this.expandOtherWorksStorageKey, 'true')
      }
    } else {
      this.expandOtherWorks = true
    }
  },
  methods: {
    getWorkPackageExpansionStorageKey: function (workPackage) {
      return `expandWorkPackage_${this.request.id}_${workPackage.id}`
    },
    onSelectInclusionMode: function (event) {
      if (event.workPackages) {
        const workPackages = JSON.parse(JSON.stringify(event.workPackages))
        delete event.workPackages
        workPackages.forEach(wP => {
          this.onSelectInclusionModeInPackage(event, wP)
        })
      } else {
        this.$emit('change-work-type', event)
      }
    },
    onSelectInclusionModeInPackage: function (event, workPackage) {
      this.$emit('change-work-type-in-package', workPackage.id, event)
    },
    isNewWorkType: function (workType) {
      return this.workTypesInitial && !this.workTypesInitial.map(wT => wT.id).includes(workType.id)
    },
    isNewWorkPackage: function (workPackage) {
      return this.workPackagesInitial && !this.workPackagesInitial.map(wP => wP.id).includes(workPackage.id)
    },
    isNewGroupedWorkType: function (workType) {
      if (workType.workPackages && workType.workPackages.length && this.workPackagesInitial) {
        return workType.workPackages.some(wP => !this.workPackagesInitial.map(wPI => wPI.name).includes(wP.name))
      } else {
        return this.isNewWorkType(workType)
      }
    },
    onSetDefaultRequiredAll: function () {
      this.workTypesLocal.forEach(wT => {
        wT.technologicalOperations.forEach(tO => {
          const newTO = JSON.parse(JSON.stringify(tO))
          const defaultTO = this.defaultWorkTypes.find(defaultWT => defaultWT.id === wT.id).technologicalOperations.find(tO => tO.id === newTO.id)
          newTO.required = defaultTO.required
          newTO.resultsRequired = defaultTO.resultsRequired
          this.onUpdateTechnologicalOperation(newTO, wT)
        })
      })
      this.workPackagesLocal.forEach(wP => {
        wP.workTypes.forEach(wT => {
          wT.technologicalOperations.forEach(tO => {
            const newTO = JSON.parse(JSON.stringify(tO))
            const defaultTO = this.defaultWorkTypes.find(defaultWT => defaultWT.id === wT.id).technologicalOperations.find(tO => tO.id === newTO.id)
            newTO.required = defaultTO.required
            newTO.resultsRequired = defaultTO.resultsRequired
            this.onUpdateTechnologicalOperation(newTO, wT, wP)
          })
        })
      })
    },
    onSetDefaultRequired: function (workTypes, workPackage = null) {
      workTypes.forEach(wT => {
        wT.technologicalOperations.forEach(tO => {
          const newTO = JSON.parse(JSON.stringify(tO))
          const defaultTO = this.defaultWorkTypes.find(defaultWT => defaultWT.id === wT.id).technologicalOperations.find(tO => tO.id === newTO.id)
          newTO.required = defaultTO.required
          newTO.resultsRequired = defaultTO.resultsRequired
          this.onUpdateTechnologicalOperation(newTO, wT, workPackage)
        })
      })
    },
    onInputRequiredAll: function () {
      const newValue = !this.requiredAll
      this.workTypesLocal.forEach(wT => {
        wT.technologicalOperations.forEach(tO => {
          const newTO = JSON.parse(JSON.stringify(tO))
          newTO.required = newValue
          if (!newValue) {
            newTO.resultsRequired = false
          }
          this.onUpdateTechnologicalOperation(newTO, wT)
        })
      })
      this.workPackagesLocal.forEach(wP => {
        wP.workTypes.forEach(wT => {
          wT.technologicalOperations.forEach(tO => {
            const newTO = JSON.parse(JSON.stringify(tO))
            newTO.required = newValue
            if (!newValue) {
              newTO.resultsRequired = false
            }
            this.onUpdateTechnologicalOperation(newTO, wT, wP)
          })
        })
      })
    },
    onInputResultsRequiredAll: function () {
      const newValue = !this.resultsRequiredAll
      this.workTypesLocal.forEach(wT => {
        wT.technologicalOperations.forEach(tO => {
          const newTO = JSON.parse(JSON.stringify(tO))
          newTO.resultsRequired = newValue
          if (newValue) {
            newTO.required = true
          }
          this.onUpdateTechnologicalOperation(newTO, wT)
        })
      })
      this.workPackagesLocal.forEach(wP => {
        wP.workTypes.forEach(wT => {
          wT.technologicalOperations.forEach(tO => {
            const newTO = JSON.parse(JSON.stringify(tO))
            newTO.resultsRequired = newValue
            if (newValue) {
              newTO.required = true
            }
            this.onUpdateTechnologicalOperation(newTO, wT, wP)
          })
        })
      })
    },
    onInputRequired: function (workTypes, workPackage = null) {
      workTypes.forEach(wT => {
        const newValue = !wT.technologicalOperations.every(tO => tO.required)
        wT.technologicalOperations.forEach(tO => {
          const newTO = JSON.parse(JSON.stringify(tO))
          newTO.required = newValue
          if (!newValue) {
            newTO.resultsRequired = false
          }
          this.onUpdateTechnologicalOperation(newTO, wT, workPackage)
        })
      })
    },
    onInputResultsRequired: function (workTypes, workPackage = null) {
      workTypes.forEach(wT => {
        const newValue = !wT.technologicalOperations.every(tO => tO.resultsRequired)
        wT.technologicalOperations.forEach(tO => {
          const newTO = JSON.parse(JSON.stringify(tO))
          newTO.resultsRequired = newValue
          if (newValue) {
            newTO.required = true
          }
          this.onUpdateTechnologicalOperation(newTO, wT, workPackage)
        })
      })
    },
    onUpdateTechnologicalOperation: function (updatedTechnologicalOperation, workType, workPackage = null) {
      workType.technologicalOperations = workType.technologicalOperations.map(tO => {
        if (tO.id === updatedTechnologicalOperation.id) {
          return updatedTechnologicalOperation
        } else {
          return tO
        }
      })
      workType.required = workType.technologicalOperations.some(tO => tO.required)
      if (workPackage) {
        this.$emit('change-work-type-in-package', workPackage.id, workType)
      } else {
        this.$emit('change-work-type', workType)
      }
    },
    getWorkPackagesWithWorkType: function (workType, workPackage) {
      return this.workPackages.filter(wP => wP.workTypes.map(wT => wT.id).includes(workType.id)).map(wP => {
        return {
          id: wP.id,
          name: wP.name,
          current: workPackage ? wP.id === workPackage.id : null
        }
      })
    },
    showHelp: function () {
      const dialog = this.$d.dialog(this).show({
        contentComponent: RequestWorkTypesListHelp,
        headerLabel: 'Справка',
        contentWidth: 1000,
        contentProps: {
          requiredSettings: this.setupTechnologicalOperations,
          isEngineerView: this.engineerView
        }
      })
    },
    getWorkTypeFromInitial: function (workTypeId) {
      if (this.workTypesInitial) {
        const initialWorkType = this.workTypesInitial.find(wT => wT.id === workTypeId)
        if (initialWorkType) {
          return initialWorkType
        } else if (this.workPackagesInitial) {
          for (const wP of this.workPackagesInitial) {
            const initialWorkTypeInPackage = wP.workTypes.find(wT => wT.id === workTypeId)
            if (initialWorkTypeInPackage) {
              return initialWorkTypeInPackage
            }
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },
    onEditGroupAll: function () {
      const dialog = this.$d.dialog(this).show({
        contentComponent: RequestWorksGroupInclusionModeEditor,
        headerLabel: `Редактировать режимы автоматического добавления работ${this.isAdditionalDeparture ? ' для дополнительного выезда' : ''}`,
        contentWidth: 1200,
        contentProps: {
          workTypes: this.workTypes,
          workPackages: this.workPackages,
          isAdditionalDeparture: this.isAdditionalDeparture,
          request: this.request
        },
        componentHandlers: {
          select: (data) => {
            if (data.workTypes) {
              data.workTypes.forEach(wT => {
                this.$emit('change-work-type', wT)
              })
            } if (data.workPackages) {
              data.workPackages.forEach(wP => {
                wP.workTypes.forEach(wT => {
                  this.$emit('change-work-type-in-package', wP.id, wT)
                })
              })
            }
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        }
      })
    },
    onEditGroupStandalone: function () {
      const dialog = this.$d.dialog(this).show({
        contentComponent: RequestWorksGroupInclusionModeEditor,
        headerLabel: `Редактировать режимы автоматического добавления работ вне комплексов${this.isAdditionalDeparture ? ' для дополнительного выезда' : ''}`,
        contentWidth: 1200,
        contentProps: {
          workTypes: this.workTypes,
          isAdditionalDeparture: this.isAdditionalDeparture,
          request: this.request
        },
        componentHandlers: {
          select: (data) => {
            if (data.workTypes) {
              data.workTypes.forEach(wT => {
                this.$emit('change-work-type', wT)
              })
            } if (data.workPackages) {
              data.workPackages.forEach(wP => {
                wP.workTypes.forEach(wT => {
                  this.$emit('change-work-type-in-package', wP.id, wT)
                })
              })
            }
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        }
      })
    },
    onResetModesChanges: function () {
      this.workTypesLocal.forEach(wT => {
        const wTInitial = this.workTypesInitial.find(localWT => localWT.id === wT.id)
        const newWT = JSON.parse(JSON.stringify(wT))
        if (wTInitial) {
          newWT.inclusionMode = wTInitial.inclusionMode
          newWT.lastAppliedInclusionMode = wTInitial.lastAppliedInclusionMode
          this.$emit('change-work-type', newWT)
        }
      })
      this.workPackagesLocal.forEach(wP => {
        const wPInitial = this.workPackagesInitial.find(localWP => localWP.id === wP.id)
        const newWP = JSON.parse(JSON.stringify(wP))
        if (wPInitial) {
          newWP.workTypes = newWP.workTypes.forEach(wT => {
            const wTInitial = wPInitial.workTypes.find(localWT => localWT.id === wT.id)
            const newWT = JSON.parse(JSON.stringify(wT))
            if (wTInitial) {
              newWT.inclusionMode = wTInitial.inclusionMode
              newWT.lastAppliedInclusionMode = wTInitial.lastAppliedInclusionMode
              this.$emit('change-work-type-in-package', wP.id, newWT)
            }
          })
        }
      })
    },
    onResetChanges: function () {
      this.$emit('reset-changes')
    },
    onWorkTypeHover: function (hover, workType) {
      if (hover) {
        this.hoveredWorkTypeId = workType.id
      } else {
        this.hoveredWorkTypeId = null
      }
    },
    isDuplicateHovered: function (workType) {
      return this.hoveredWorkTypeId === workType.id && this.hoveredWorkTypeHasDuplicates
    },
    toggleExpandAll: function () {
      const newValue = !this.isAllExpanded
      if (this.showWorkPackages) {
        this.workPackagesLocal.forEach(wP => {
          this.$set(this.expandWorkPackages, wP.key, newValue)
        })
      }
      this.expandOtherWorks = newValue
    }
  }
}
